// After a part-tip of a bulk-sort pallet (T6) its sticker shows the old crate
// count. The floor taps Reprint and sticks the new label over the old one
// (Thomas, 2 Nov). Shown on the Tipping page right after the tip and on the
// bin's page. The print is the bin label page (BinLabel.tsx), in a new tab so
// the screen behind stays where it was.

import { Link } from 'react-router-dom'
import { Printer } from 'lucide-react'

export default function BinReprintNotice({ binId, binNumber, left, onReprint }: {
  binId: string
  binNumber: string
  left: number
  onReprint?: () => void
}) {
  return (
    <div role="status" className="card p-3 flex items-center gap-3">
      <p className="text-sm text-fg flex-1 min-w-0">
        {left} crate{left === 1 ? '' : 's'} left on <span className="font-mono">{binNumber}</span>.
        Reprint its sticker and stick it over the old one.
      </p>
      <Link to={`/bin-label/${binId}`} target="_blank" rel="noopener" onClick={onReprint}
        className="btn-primary btn-sm tap-target-y shrink-0 flex items-center gap-1.5">
        <Printer size={14} /> Reprint
      </Link>
    </div>
  )
}
